<template lang="pug">
    v-dialog( fullscreen max-width="80%" v-model="open" )
        v-toolbar( color="grey darken-4" dark sticky flat )
            v-toolbar-title Detalle de Factura  
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-card
            v-layout.pa-3( row wrap )
                v-flex( xs12 )
                    model-form(
                        v-bind="formProps"
                        v-model="formData"
                        no-buttons
                        )
            
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
// import {
//     getFetchDataFunction,
//     generateFetchDataFunction,
// } from '@/services/api/DataTableService'
import InvoiceService from '@/services/api/invoice/'
import headerTable from './headers/headerTable.js'
import fieldForm from './fields/fieldsForm.js'
//-
export default {
    name: 'invoice-Detail',
    props: {
        invoiceId: {
            type: String,
            required: true,
        },
        /**
         * @description
         */
        readOnly: {
            type: Boolean,
            default: () => false,
        },
    },
    data: function() {
        return {
            formData: {},
            formFields: fieldForm,
            open: false,
            headerTable: headerTable,
            fieldsForm: fieldForm,
            loadingForm: false,
        }
    },
    computed: {
        //-
        formProps() {
            return {
                fields: this.formFields,
                editable: false,
                switchEdit: false,
                readOnly: true,
                loading: this.loadingForm,
            }
        },
        //-
        fld: function() {
            if (this.readOnly)
                return this.fieldsForm.map(field => {
                    field.type = 'readonly'
                    return field
                })
            return this.fieldsForm
        },
    },
    methods: {
        toggleOpen() {
            this.open = !this.open
        },
        /**
         *
         */
        getGeneralInfoInvoice() {
            this.loadingForm = true
            InvoiceService.fetchById(this.invoiceId)
                .then(this.fillForm)
                .catch(e => {
                    console.log('e: ', e)
                    this.loadingForm = false
                })
        },
        /**
         *
         */
        fillForm(model) {
            model.invoice_type = this.typeSiiDocument(model.dte_type_invoice)
            model.invoice_number = model.number
            model.sl_detail_sale_invoices = model.sl_detail_sale_invoices.map(
                r => {
                    r.wh_product_name = r.wh_product.name
                    return r
                }
            )
            this.formData = model
            this.loadingForm = false
        },
        /**
         *
         */
        typeSiiDocument(code) {
            const SII_DOCUMENTS = [
                {
                    code: 33,
                    name: 'Factura Electrónica',
                },
                {
                    code: 39,
                    name: 'Boleta Electrónica',
                },
                {
                    code: 61,
                    name: 'Nota de crédito',
                },
            ]
            let foundDocument = SII_DOCUMENTS.filter(item => {
                if (item.code === code) {
                    return item
                }
            })
            return foundDocument
                ? foundDocument[0].name
                : `código ${code} no encontrado`
        },
    },
    watch: {
        open(val) {
            if (val == true) {
                this.getGeneralInfoInvoice()
            }
        },
    },
    components: {
        'model-form': ModelForm,
    },
    updated: function() {
        //this.getInvoiceRecentInformation()
    },
}
</script>

<style lang="scss"></style>
